<div class="d-flex justify-content-between">
    <label [ngbTooltip]="statusTooltip$ | async">{{ ('DataList.Columns.' + user.userStatus) | translate }}</label>

    @if (!user.isCurrentUser && do.stop) {
        <i class="far fa-stop-circle align-content-center" (click)="do.stop()" ngbTooltip="{{ 'DataList.Tooltips.Stop' | translate}}"></i>
    }
    @if (!user.isCurrentUser && do.start) {
        <i class="far fa-play-circle align-content-center" (click)="do.start()" ngbTooltip="{{ 'DataList.Tooltips.Start' | translate}}"></i>
    }
    @if (do.resend) {
        <i class="far fa-redo-alt align-content-center" (click)="do.resend()" ngbTooltip="{{ 'DataList.Tooltips.Resend' | translate}}"></i>
    }
    @if (do.view) {
        <i class="far fa-eye align-content-center" (click)="do.view()" ngbTooltip="{{ 'DataList.Tooltips.View' | translate}}"></i>
    }
    @if (do.edit) {
        <i class="far fa-edit align-content-center" (click)="do.edit()" ngbTooltip="{{ 'DataList.Tooltips.Edit' | translate}}"></i>
    }
</div>
